<template>
  <div
    v-loading="!questionnaires"
    class="tw-h-full"
  >
    <div v-if="questionnaires.length > 0">
      <div
        class="tw-flex tw-gap-5 tw-mb-3 tw-px-6"
      >
        <div
          class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-5"
          :style="`width: ${columnWidths.type}`"
        >
          {{ $t('quest.quest_type') }}
        </div>
        <div
          class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-5"
          :style="`width: ${columnWidths.status}`"
        >
          {{ $t('common.filters.status') }}
        </div>
        <div
          class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-5"
          :style="`width: ${columnWidths.isSubmitted}`"
        >
          {{ $t('quest.submitted') }}
        </div>
      </div>

      <div>
        <ForeignerQuestionnairesListItem
          v-for="questionnaire in questionnaires"
          :key="questionnaire.id"
          :questionnaire="questionnaire"
        />
      </div>
    </div>
    <div
      v-else
      class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
    >
      {{ $t('common.search.empty') }}
    </div>
  </div>
</template>

<script>
import ForeignerQuestionnairesListItem
  from '@/components/Foreigner/Questionnaires/ForeignerQuestionnairesListItem.vue';
import { columnWidths } from '@/components/Foreigner/Questionnaires/columns';
import { mapState } from 'vuex';

export default {
  name: 'ForeignerQuestionnaires',
  components: { ForeignerQuestionnairesListItem },
  computed: {
    columnWidths() {
      return columnWidths;
    },
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      foreigner: (state) => state.v2.foreigner.foreigner.foreigner,
      questionnaires: (state) => state.v2.foreigner.questionnaires.questionnaires,
    }),
    foreignerIdToLoad() {
      return this.$route.params.fid ?? this.me.id;
    },
  },

  mounted() {
    this.$store.dispatch('v2/foreigner/questionnaires/loadByForeignerId', { foreignerId: this.foreignerIdToLoad });
  },
};
</script>
